import {apiSlice} from './apiSlice';

const fieldMappings = {
  // firstName: 'first_name',
  // lastName: 'last_name',
  selectedProviderId: 'selectedProviderId',
  sessionType: 'sessionType',
  dateOfBirth: 'date_birth',
  phone: 'phone',
  addressLine1: 'address_line_1',
  addressLine2: 'address_line_2',
  city: 'address_city',
  state: 'address_state',
  zip: 'address_zip',
  contractName: 'contract_name',
  contractDate: 'contract_date',
  signature: 'contract_signature',
  pronouns: 'personal_pronouns',
  patientReferral: 'patient_referral',
  patientReferralDetails: 'referral_details',
  optionalNote: 'opt_note',
  promoCode: 'promo_code',
  hasGuardian: 'has_guardian',
  guardianFirstName: 'guardian_first_name',
  guardianLastName: 'guardian_last_name',
  guardianPhone: 'guardian_phone',
  guardianEmail: 'guardian_email',
  guardianRelation: 'guardian_relation',
  completedOnboarding: 'completed_onboarding',
};

const mapFieldsToApi = body => {
  const keys = Object.keys(body);
  const newBody = keys.reduce((acc, k) => (
    fieldMappings[k]
    ? {...acc, [fieldMappings[k]]: body[k]}
    : {...acc, [k]: body[k]}
  ), {});
  return newBody;
};

// Define a service using a base URL and expected endpoints
export const patientApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPatientById: builder.query({
      query: (id) => `patient/${id}`,
      providesTags: ['Patient'],
    }),
    getCurrentPatient: builder.query({
      query: (id) => `patient/current/`,
      providesTags: ['Patient'],
    }),
    getPatients: builder.query({
      query: filters => {
        const qs = Object.keys(filters).reduce((acc, k) => {
          acc.set(k, filters[k]);
          return acc;
        }, new URLSearchParams());
        return `patient/?${qs}`;
      },
      providesTags: ['Patient'],
    }),
    createPatient: builder.mutation({
      query: body => ({
        url: 'user/',
        method: 'POST',
        body: {...body, email: (body.email || '').toLowerCase()}
      }),
      invalidatesTags: ['Patient', 'Session'],
    }),
    updatePatient: builder.mutation({
      query: ({ id, body }) => ({
        url: `patient/${id}/`,
        method: 'PUT',
        body: mapFieldsToApi(body),
      }),
      invalidatesTags: ['Patient', 'Session'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetPatientByIdQuery,
  useGetCurrentPatientQuery,
  useGetPatientsQuery,
  useCreatePatientMutation,
  useUpdatePatientMutation,
} = patientApi;
